export default {
  products: [],
  productCategories: [],
  customProductCategories: [],
  productCompanies: [],
  companyWithProducts: null,
};
